import React from 'react';
import LogLineRow from './LogLineRow';
import logLevels from '../../../const/logLevels';

class LogLineContent extends React.Component {

    render() {
        let {
            log,
            showJsonData,
            isNew,
            maxLineLog,
            maxScriptNameWidth,
            hasAudioPreview,
            hasImagePreview,
            setFilterByPhrase,
            filterUpdateTs,
            filters
        } = this.props;
        let isPhrase = log.level === logLevels.phrase;
        let isFullRow = !(log.file || log.line !== 0);
        let msg = log.reason || log.message || log.phrase;
        return <div className={`log-line oc_log-line log-line-content ${isFullRow && 'full-log-row'}`}>
            <LogLineRow log={log}
                        title={msg}
                        filterUpdateTs={filterUpdateTs}
                        filters={filters}
                        maxLineLog={maxLineLog}
                        maxScriptNameWidth={maxScriptNameWidth}
                        hasAudioPreview={hasAudioPreview}
                        hasImagePreview={hasImagePreview}
                        isNew={isNew}
                        showJsonData={showJsonData}
                        setFilterByPhrase={setFilterByPhrase}
                        goToCb={this.props.goToCb}
                        onToggleJsonDataCb={this.props.onToggleJsonDataCb}
                        intentLinkMode={this.props.intentLinkMode}
                        onJsonObjClick={this.props.onJsonObjClick}
                        environment={this.props.environment}
            />
        </div>;
    }
}

export default LogLineContent;
